import CustomSelect from "../../../../components/CustomSelect/CustomSelect";

const Select = ({id, formik, settings = {}}) => {

    return (
        <CustomSelect
            id={id}
            label={settings.title}
            value={settings.options.find(option => option.value === formik.values[id])}
            options={settings.options}
            required={settings.required}
            description={settings.description}
            onChange={(selectedOption) => {formik.setFieldValue(id, selectedOption.value)}}
            onBlur={formik.handleBlur}
            error={formik.touched[id] && formik.errors[id]}
        />
    )
};

export default Select;